import React, { type FunctionComponent } from 'react'
import { colors, fontSize, fontWeight, spacing } from '@retailer-platform/shared-components'
import { css } from '@emotion/react'

export interface CollectionsFormInputWrapperProps {
  label?: string
  maxLength?: number
  showLength?: boolean
  value?: string
}

const labelStyles = css({
  display: 'block',
  fontSize: fontSize.X12,
  fontWeight: fontWeight.SEMIBOLD,
  marginBottom: spacing.X8,
})

const lengthStyles = css({
  color: colors.GRAYSCALE.X50,
  fontSize: fontSize.X12,
  margin: `${spacing.X4} ${spacing.X8} 0 0`,
  display: 'flex',
  justifyContent: 'flex-end',
})

export const CollectionsFormInputWrapper: FunctionComponent<CollectionsFormInputWrapperProps> = ({
  value,
  maxLength,
  showLength,
  label,
  children,
}) => (
  <label>
    {label && <span css={labelStyles}>{label}</span>}

    {children}

    {showLength && (
      <span css={lengthStyles}>
        {value?.length || 0}
        {maxLength && ` / ${maxLength}`}
      </span>
    )}
  </label>
)
